import { useState, type ReactNode } from 'react';
import { Icon } from '@hp/ui';

/** Collapsed section card (manual controls, run histories). Children render only when open. */
export function Disclosure({
  title,
  caption,
  defaultOpen = false,
  flush = false,
  children,
}: {
  title: ReactNode;
  /** Extra inline nodes after the title (captions etc.). */
  caption?: ReactNode;
  defaultOpen?: boolean;
  /** No body padding — for a table that should touch the card edges. */
  flush?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="hp-card bo-disclosure">
      <button type="button" className="bo-disclosure__summary" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <Icon name="chevronDown" className={open ? 'is-open' : undefined} />
        <span className="bo-disclosure__title">{title}</span>
        {caption && <span className="bo-disclosure__caption">{caption}</span>}
      </button>
      {open && (
        <div className={flush ? 'bo-disclosure__body bo-disclosure__body--flush' : 'bo-disclosure__body'}>
          {children}
        </div>
      )}
    </section>
  );
}
